// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var CityGuideRoute = function CityGuideRoute() {
  return {
    path: 'locations',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('./CityGuideIndex').CityGuideIndex
        });
      }, 'CityGuideIndex');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: ':locationAlias',
          component: require('./CityGuideContainer').CityGuideContainer
        }]);
      }, 'CityGuide');
    }
  };
};